import React from "react";
import "./DoctorListJoyRide.scss";

const DoctorListJoyRides = (props) => {
  const { steps, callback, run } = props;

  return <div></div>;
};

export default DoctorListJoyRides;
